import { Wrapper } from './styles'

export type IImageProps = React.ImgHTMLAttributes<HTMLImageElement>

export function Image({ children, ...props }: IImageProps) {
  return <Wrapper data-testid="image-component" {...props} />
}
